module.exports = __webpack_public_path__ + "static/sheeptowel-0112788cb5bc55fc07c19602e1853828.png";